import HeadMetadata from 'components/shared/HeadMetadata';
import { MagnetIAPage } from 'features/magnets/ia';
import { useI18n } from 'hooks/useI18n';
import { usePageTrack } from 'hooks/usePageTrack';
import { WithBaseUrl } from 'interfaces/ui/with-base-url';
import { GetStaticProps } from 'next';
import { serverSideTranslations } from 'next-i18next/serverSideTranslations';
import { APP_URLS } from 'utils/app-urls';
import { config } from 'utils/config';
import { getPublicPath } from 'utils/paths';

type RolesPageProps = WithBaseUrl;

const MangetsIaPage: React.FC<RolesPageProps> = ({ baseUrl }) => {
  const { t } = useI18n('magnets');

  usePageTrack('Landing - Page Loaded');

  return (
    <>
      <HeadMetadata
        url={APP_URLS.magnetsIA}
        title={t('magnets.ia.page-title')}
        desc={t('magnets.ia.page-description')}
        imgUrl={`${baseUrl}${getPublicPath(
          '/images/cards/card_magnets_ia.png'
        )}`}
      />

      <MagnetIAPage />
    </>
  );
};

export default MangetsIaPage;

export const getStaticProps: GetStaticProps = async ({ locale }) => {
  return {
    props: {
      ...(await serverSideTranslations(locale || '', [
        'common',
        'topbar',
        'footer',
        'magnets'
      ])),
      baseUrl: config.appUrl
    },
    revalidate: 30
  };
};
